import moment from "moment";
export const planetChartData = {
  type: 'line',
  data: {
    labels: ['Trading', 'Martes', 'Miercoles', 'Mars', 'Jupiter', 'Saturn', 'Uranus', 'Neptune'],
    datasets: [
      { // one line graph
        label: 'Porcentaje de disponibilidad por dias',
        data: [0, 0, 1, 2, 67, 62, 27, 14],

        backgroundColor: 'rgba(27, 107, 157, .4)',
        borderColor: 'rgba(27, 107, 157, 1)',
        borderWidth: 2
      }

    ]
  },
  options: {
    responsive: true,
    maintainAspectRatio: false,
    lineTension: 0,
    scales: {
      yAxes: [{
        ticks: {
          callback: function (value) {
            return value + " %";
          },

          min: 0,
          max: 100,

          beginAtZero: true
        },
        scaleLabel: {
          display: true,
          fontSize: 12,

        }
      }],
      xAxes: [{
        ticks: {
          autoSkip: false,
          callback: function (value) {

            let diaMayuscula = moment(value, "YYYY-MM-DD").format('dddd');
            return diaMayuscula.toUpperCase();
          }

        }
      }]
    },
    tooltips: {
      callbacks: {
        title: function (tooltipItems) {
          return moment(tooltipItems[0].xLabel, "YYYY-MM-DD").format("LL");
        },
        label: function (tooltipItem, data) {
          let label = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index]
          return label + ' %';
        },
      }
    }




  }
}

export default planetChartData;